import { Component, inject } from "@angular/core"
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from "@angular/common"
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"

enum FileType {
    IMAGE = "img",
    VIDEO = "video",
    UNKNOWN = "unknown",
}

@Component({
    selector: "valben-file-dialog",
    templateUrl: "./file-dialog.component.html",
    standalone: true,
    imports: [NgSwitch, NgSwitchCase, NgSwitchDefault, MatDialogContent, MatDialogClose, MatIcon],
})
export class FileDialogComponent {
    private readonly _imgExts: string[] = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"]
    private readonly _vidExts: string[] = ["mp4", "webm", "ogg", "avi", "mov"]

    readonly src = inject<string>(MAT_DIALOG_DATA)
    fileType: FileType = FileType.IMAGE

    constructor() {
        try {
            const url = new URL(this.src)
            const fileExt = url.pathname.split(".").pop()?.toLowerCase()
            if (!fileExt) return
            if (this._imgExts.includes(fileExt))
                this.fileType = FileType.IMAGE
            else if (this._vidExts.includes(fileExt))
                this.fileType = FileType.VIDEO
        } catch {
            this.fileType = FileType.UNKNOWN
        }
    }

    onErr(): void {
        if (this.fileType === FileType.IMAGE)
            this.fileType = FileType.VIDEO
        else if (this.fileType === FileType.VIDEO)
            this.fileType = FileType.UNKNOWN
    }
}
